import * as React from 'react';
import { ReactNode } from 'react';
import { ComplexValue, ComponentProps } from 'ui';

type TitleWrapperProps = { title: string | ComplexValue<any>; children: ReactNode} & ComponentProps;

export const TitleWrapper: React.FC<React.PropsWithChildren<TitleWrapperProps>> = (props) => {
  const { title, children } = props;

  const titleDescription = (title as ComplexValue<any>)?.description || title as string;

  return <div id={props.componentId} className={props.className}>
    <label className="label">{titleDescription}</label>
    {children}
  </div>;

};
